import { CardActionArea, Chip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useRef, useState } from "react";
import he from 'he';
import { formatDate } from '../functions/dateFormat';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import getTaxonomy from "../functions/getTaxonomy";

export default function SliderCard({ post, isDragging }) {

    const navigate = useNavigate();
    return (


        <Box
            //component={RouterLink}

            onClick={() => {

                if (isDragging) {
                    console.log('isDragging', isDragging)
                    return null
                } else {
                    console.log('clicked', post.slug)
                    navigate(`/insights/${post?.slug}/`)
                }
            }}
            sx={{
                '&:hover': {
                    '& .MuiCardActionArea-focusHighlight': {
                        opacity: 0,
                    },
                    '& .card-image': {
                        opacity: '1!important',
                    },
                },
            }}
        >

            <Box

                sx={{
                    position: 'relative',
                }}
            >
                <Box
                    style={{
                        width: '100%',
                        height: '300px',
                        position: 'relative',
                    }}
                >
                    <Box
                        className="card-image"
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(53, 92, 160, 0.2)',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            zIndex: 1,
                        }}
                    />
                    <img
                        alt={post.title}
                        src={post.featured_image_src}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '100%',
                        p: '0.5rem',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        zIndex: 2,
                    }}
                >
                    {post.categories.map((cat) => {
                        const theCat = getTaxonomy(cat, post._embedded['wp:term']);
                        const featured = theCat.name === 'Featured';
                        return (
                            <Chip
                                label={he.decode(theCat.name)}
                                sx={{
                                    backgroundColor: featured ? '#E75421' : '#fff',
                                    color: featured ? '#fff' : '#000',
                                    ml: '0.25rem',
                                    fontWeight: 600
                                }}
                            />
                        );
                    })}
                </Box>
                <Box

                    sx={{
                        fontSize: '0.8rem',
                        margin: '16px 0 10px 0',
                    }}
                >
                    <span dangerouslySetInnerHTML={{ __html: getTaxonomy(post.topic[0], post._embedded['wp:term']).name }} /> | {formatDate(post.date)}
                </Box>

                <Typography
                    variant="h3"
                    sx={{
                        color: "#E9531C",
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        marginBottom: "10px",
                    }}
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                />
                <Typography variant='p' component='p'
                    sx={{
                        pb: '2rem'
                    }}
                >
                    {he.decode(post.excerpt.rendered)}
                </Typography>
            </Box>
        </Box>
    );
}